import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledHamburgerMenu = styled.div`
  position: fixed;
  top: 70px; // Should match the header height
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${props => props.isOpen ? '#111113' : 'transparent'};
  transition: background-color 0.3s ease;
  pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
  z-index: 1000;
`;

export const StyledHamburgerIcon = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #ffe955;
  z-index: 1002;
`;

export const StyledMenuItems = styled.div`
  position: fixed;
  top: 90px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #111113;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 1000;
`;

export const DiscoverDropdownContent = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  background-color: #111113;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  padding: 20px; // Increased from 15px to 20px
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0;
  z-index: 1000;
  min-width: 250px; // Increased from 225px to 250px
  transition: opacity 0.5s ease, visibility 0.5s ease;
`;

export const DropdownLink = styled.a`
  color: #ffffff!important;
  text-decoration: none;
  font-size: 1.25rem;
  display: block;
  padding: 10px 0; // Increased from 8px to 10px
  cursor: pointer;

  &:hover {
    color: #ffe955!important;
  }
`;

export const DropdownDivider = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin: 12px 0; // Increased from 8px to 12px
  width: 100%;
`;

export const DiscoverDropdownContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const StyledDiscoverLink = styled.div`
  height: 60px;
  font-size: 1.2rem;
  font-weight: normal; // Explicitly set normal font weight
  padding: 0 20px;
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  color: ${props => props.isActive ? '#ffe955' : 'white'};

  &:hover {
    color: #ffe955;
  }

  /* Removing the carat since we'll use the react-feather icon instead */
  &::after {
    display: none;
  }
`;

export const StyledBrandLink = styled.a`
  color: white;
  text-decoration: none;
  display: block;
  padding: 5px 0;
  font-size: 1rem;

  &:hover {
    color: #ffe955;
  }
`;

export const StyledHeader = styled.header`
  position: sticky;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 70px;
  background-color: #111113;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const HeaderContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`;

export const LogoContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  img {
    height: 35px;
  }
`

export const CenterNavLinks = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  
  a {
    margin: 0 10px;
    color: white;
    text-decoration: none;
    
    &:hover {
      color: #ffe955;
    }
  }
`;

export const RightNavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StyledNavLink = styled(Link)`
  font-weight: 600;
  font-size: 16px;
  padding: 8px 16px;
  cursor: pointer!important;
  color: white;
  display: flex;
  height: 100%; // Changed from fixed height to 100%
  align-items: center;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.3s ease;
  &.login {
    color: #ffffff;
    background-color: transparent;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
  &.signup {
    background-color: #ffe955;
    color: #000000;

    &:hover {
      background-color: #FFC000;
    }
  }

  &.cart {
    background-color: transparent;
    color: #fff;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  .a {
    color: white!important;
    cursor: pointer!important;
  }
`;

export const NavItem = styled.div`
  position: relative;
  padding: 0 5px;
  align-content: center;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 20px; // Adjust this value to change the height of the divider
    width: 1px;
    background-color: rgba(255, 255, 255, 0.3); // Adjust color as needed
  }
`;